import { DEFAULT_TABLE_SIZE, TABLE_SIZE_THEMES } from '../consts';
import { TableSize } from '../types';

export default (size: TableSize = DEFAULT_TABLE_SIZE) =>
  TABLE_SIZE_THEMES[size];
